export const state = {
  loading: false,
  error: "",
  auth_error: "",
  token: "",
  success_msg: "",
  images: [],
  language: "eng",
  theme: "",
  categories: [],
  requests: [],
  templates: [],
  singleReq: [],
  filters: {
    category: "",
    sub_category: "",
  },
  progress_monitor_bool: false,
  progress_monitor_reflected_indexes: 0,
  monitor_id: 0,
  monitor_current_progress: 0,
  monitor_max_progress: 0,
};
